import { FileUpload, Icon } from '@ab-inbev-maz/compass';

interface DetailPageFileUploadProps {
  itemType: 'Template' | 'SKU';
  refImage: React.RefObject<File | null>;
}

const DetailPageFileUpload = ({ itemType, refImage }: DetailPageFileUploadProps) => {
  return (
    <FileUpload
      img={<img alt="upload file" className="h-10 w-10" src="data:image/svg+xml,%3csvg%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0.501221%206.66927C0.501221%204.82832%201.9936%203.33594%203.83455%203.33594H15.8346C16.3292%203.33594%2016.7983%203.55564%2017.1149%203.93563L20.7818%208.33594H36.1679C38.0089%208.33594%2039.5012%209.8283%2039.5012%2011.6693V33.3359C39.5012%2035.1769%2038.0089%2036.6693%2036.1679%2036.6693H3.83455C1.99362%2036.6693%200.501221%2035.1769%200.501221%2033.3359V6.66927Z'%20fill='%23007A78'%20/%3e%3cpath%20d='M24%2021L20%2017L16%2021'%20stroke='%239CFFFD'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M20%2017L20%2031'%20stroke='%239CFFFD'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3c/svg%3e" />}
      label={`Carga de imágenes para un nuevo ${itemType}`}
      help={<div className="text-sm text-center max-w-[600px] px-3">El sistema solo permite cargar un archivo, <strong>exclusivamente en formato .PNG, .JPG, .JPEG, .WEBP</strong>. No se aceptan otros formatos. El tamaño máximo por archivo es de 2MB.</div>}
      instructions={<><span className="flex h-6 w-6"><Icon name="file/file-upload" /></span><p className="text-sm font-semibold underline">Selecciona o arrastra aquí tu imagen</p></>}
      accept={".png,.jpg,.jpeg, .webp"}
      maxSize={2 * 1024 * 1024}
      maxSizeErrorMessage={`El tamaño del archivo excede el límite de 2MB`}
      multiple={false}
      onChange={(e) => {
        if (e?.target?.files?.[0]) {
          refImage.current = e.target.files?.[0];
        }
      }}
      className="max-w-full! [&>:first-child]:bg-white mt-4 gap-4! [&>ul>li>div>img]:max-h-full [&>ul>li>div>img]:mx-auto"
    />
  );
};

export default DetailPageFileUpload;
